var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33834 12.2417C6.32307 12.2936 6.30933 12.3368 6.29763 12.3806C5.63626 14.9706 5.56301 15.546 4.88384 16.7497C4.55926 17.321 4.1945 17.8628 3.79056 18.3817C3.74477 18.4402 3.70255 18.5155 3.61148 18.4972C3.51177 18.4758 3.50412 18.3863 3.49293 18.3064C3.38406 17.5194 3.32455 16.7298 3.3505 15.9357C3.38458 14.9004 3.51276 14.5453 4.8472 8.93284C4.86704 8.84737 4.84516 8.77666 4.81667 8.69882C4.49718 7.83752 4.43411 6.96299 4.7129 6.07676C5.31678 4.16236 7.48706 4.01584 7.86658 5.59549C8.10009 6.57227 7.48199 7.85023 7.00733 9.7397C6.61408 11.299 8.44909 12.407 10.0181 11.269C11.4639 10.22 12.0256 7.70423 11.9187 5.92159C11.7086 2.36752 7.81165 1.59932 5.33815 2.74399C2.50394 4.05451 1.85935 7.56839 3.13935 9.17398C3.30113 9.37849 3.4263 9.50314 3.37289 9.71071C3.29047 10.0317 3.21772 10.3558 3.1292 10.6758C3.06306 10.9134 2.8636 11.0004 2.62297 10.9022C2.15136 10.7114 1.75812 10.4112 1.43914 10.0154C0.352468 8.66982 0.0416091 6.00706 1.4783 3.75384C3.07066 1.25642 6.03259 0.246569 8.73605 0.553341C11.9655 0.920144 14.0066 3.12707 14.3892 5.63008C14.5632 6.77069 14.438 9.5825 12.8375 11.5702C10.9953 13.8539 8.01005 14.005 6.63289 12.6034C6.52707 12.4961 6.44212 12.3699 6.33834 12.2417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPine);
export default __webpack_public_path__ + "static/media/pine.7dd64ab872bfa4ef60ad3357ba19880a.svg";
export { ForwardRef as ReactComponent };